export const GlobalStyle = `

* {
  box-sizing: border-box;
  font-family: var(--rag) !important;
  :focus-visible {
    border: 2px dashed white;
    outline-offset: 2px;
    outline: 3px dashed #10059f;
  }

}


:root {
  direction: rtl;
  font-family: var(--rag) !important;
  direction: rtl;


}


body {
  font-family: var(--rag) !important;
}

html {
  overscroll-behavior-x: none;
}

  .swiper {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: calc(100% - 40px);
  }

  .swiper-slide img {
    display: block;
    width: 100%;
  }
  .swiper-button-disabled {
    opacity:0.3;
  }
  .MuiPopover-root{
    z-index:1000000 !important;
  }
#bthn #bthnLink{
font-family: "Open Sans", Arial, Helvetica, sans-serif !important;}

/* CMS Rich Text Table Styles — ASH-287 */
@media (max-width: 1100px) {
  *:has(table:not(.MuiTable-root)) {
    max-width: 100%;
  }
}
*:has(> table:not(.MuiTable-root)) {
  overflow-x: auto;
  overflow-y: hidden;
}

table:not(.MuiTable-root) {
  border-collapse: separate !important;
  border-spacing: 0 !important;
  border: 2px solid #f7f7f7 !important;
  border-radius: 16px;
  overflow: hidden;
  width: 100% !important;
  height: auto !important;
  background-color: #fff;
}

@media (max-width: 1100px) {
  table:not(.MuiTable-root) {
    display: block;
    overflow-x: auto;
    overflow-y: hidden;
    min-width: 0;
    max-width: 100%;
    height: auto !important;
  }
  table:not(.MuiTable-root) tbody {
    display: table;
    width: 100%;
  }
}

table:not(.MuiTable-root) thead th,
table:not(.MuiTable-root) thead td,
table:not(.MuiTable-root) tbody tr:first-child th,
table:not(.MuiTable-root):not(:has(thead)) tbody tr:first-child td {
  background-color: #2768a3;
  color: #fff;
  font-weight: 600;
  font-size: 20px;
  line-height: normal;
  padding: 8px 16px !important;
  text-align: start;
  border: none !important;
  border-bottom: 1px solid #f7f7f7 !important;
}

table:not(.MuiTable-root) thead th:last-child,
table:not(.MuiTable-root) thead td:last-child {
  text-align: end;
}

table:not(.MuiTable-root)[dir="ltr"] thead th:last-child,
table:not(.MuiTable-root)[dir="ltr"] thead td:last-child {
  text-align: start;
}

table:not(.MuiTable-root)[dir="ltr"] thead th:first-child,
table:not(.MuiTable-root)[dir="ltr"] thead td:first-child {
  text-align: end;
}

table:not(.MuiTable-root) td {
  font-size: 18px;
  font-weight: 400;
  color: #000;
  padding: 8px 16px !important;
  text-align: start;
  border: none !important;
  border-bottom: 1px solid #f7f7f7 !important;
  height: auto !important;
}

table:not(.MuiTable-root)[dir="ltr"] td:first-child {
  text-align: end;
}

table:not(.MuiTable-root) tr {
  height: auto !important;
}

table:not(.MuiTable-root) tbody tr:last-child td,
table:not(.MuiTable-root) tfoot td,
table:not(.MuiTable-root) tfoot th {
  border-bottom: none !important;
}

table:not(.MuiTable-root) tfoot td,
table:not(.MuiTable-root) tfoot th {
  background-color: #f7f7f7;
  font-weight: 600;
  font-size: 20px;
  padding: 16px !important;
  text-align: start;
}

[dir="ltr"] table:not(.MuiTable-root) thead th,
[dir="ltr"] table:not(.MuiTable-root) thead td,
[dir="ltr"] table:not(.MuiTable-root) tbody tr:first-child th,
[dir="ltr"] table:not(.MuiTable-root):not(:has(thead)) tbody tr:first-child td,
[dir="ltr"] table:not(.MuiTable-root) td,
[dir="ltr"] table:not(.MuiTable-root) tfoot td,
[dir="ltr"] table:not(.MuiTable-root) tfoot th {
  text-align: start;
}

@media (max-width: 768px) {
  table:not(.MuiTable-root) thead th,
  table:not(.MuiTable-root) thead td,
  table:not(.MuiTable-root) tbody tr:first-child th,
  table:not(.MuiTable-root):not(:has(thead)) tbody tr:first-child td {
    font-size: 16px;
    padding: 8px 12px !important;
  }
  table:not(.MuiTable-root) td {
    font-size: 14px;
    padding: 8px 12px !important;
  }
  table:not(.MuiTable-root) tfoot td,
  table:not(.MuiTable-root) tfoot th {
    font-size: 16px;
    padding: 12px !important;
  }
}

`
